import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import SingleSelectFilterModal from "../../../ui/components/filters/SingleSelectFilterModal";

const OriginFilterModal = ({
  isOpen,
  onClose,
  onApply,
  currentOriginFilter,
  originOptions = [],
}) => {
  const { t } = useTranslation();
  const options = useMemo(
    () => [
      { label: t("All"), value: "all" },
      ...originOptions.map((option) => ({
        value: String(option.value),
        label: option.label,
      })),
    ],
    [t, originOptions],
  );

  return (
    <SingleSelectFilterModal
      isOpen={isOpen}
      onClose={onClose}
      onApply={onApply}
      title={t("Waste origin")}
      options={options}
      currentValue={currentOriginFilter || "all"}
    />
  );
};

export default OriginFilterModal;
